/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1sKx9ffix1qWmdscEUQHh6
// Component: MzgISFkf8fEm
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import ButtonPage from "../../ButtonPage"; // plasmic-import: voJV0X1zqcH0/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/projectcss
import sty from "./PlasmicTopNav.module.css"; // plasmic-import: MzgISFkf8fEm/css

createPlasmicElementProxy;

export const PlasmicTopNav__VariantProps = new Array("layoutType");

export const PlasmicTopNav__ArgProps = new Array(
  "pageButtons",
  "subdomainName"
);

const $$ = {};

function PlasmicTopNav__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          subdomainName: "subName"
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "layoutType",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.layoutType
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"topnav"}
      data-plasmic-override={overrides.topnav}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.topnav,
        {
          [sty.topnavlayoutType_titleButtons]: hasVariant(
            $state,
            "layoutType",
            "titleButtons"
          )
        }
      )}
    >
      <div
        data-plasmic-name={"pageTitleSlot"}
        data-plasmic-override={overrides.pageTitleSlot}
        className={classNames(projectcss.all, sty.pageTitleSlot, {
          [sty.pageTitleSlotlayoutType_justTitle]: hasVariant(
            $state,
            "layoutType",
            "justTitle"
          ),
          [sty.pageTitleSlotlayoutType_titleButtons]: hasVariant(
            $state,
            "layoutType",
            "titleButtons"
          )
        })}
      >
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__sVr3S
          )}
        >
          {"["}
        </div>
        <ButtonPage
          className={classNames("__wab_instance", sty.buttonPage___44EX)}
          content={"o21p"}
          onClick={async () => {
            const $steps = {};
            $steps["goToHttpsO21PCom"] = true
              ? (() => {
                  const actionArgs = { destination: "https://o21p.com/" };
                  return (({ destination }) => {
                    if (
                      typeof destination === "string" &&
                      destination.startsWith("#")
                    ) {
                      document
                        .getElementById(destination.substr(1))
                        .scrollIntoView({ behavior: "smooth" });
                    } else {
                      location.assign(destination);
                    }
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
            if (
              $steps["goToHttpsO21PCom"] != null &&
              typeof $steps["goToHttpsO21PCom"] === "object" &&
              typeof $steps["goToHttpsO21PCom"].then === "function"
            ) {
              $steps["goToHttpsO21PCom"] = await $steps["goToHttpsO21PCom"];
            }
          }}
          textColor={"tertiary"}
        />

        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__f406V
          )}
        >
          {"|"}
        </div>
        <ButtonPage
          className={classNames("__wab_instance", sty.buttonPage__kEedG)}
          content={"partner"}
          onClick={async () => {
            const $steps = {};
            $steps["goToPartnerOverview"] = true
              ? (() => {
                  const actionArgs = { destination: `/` };
                  return (({ destination }) => {
                    if (
                      typeof destination === "string" &&
                      destination.startsWith("#")
                    ) {
                      document
                        .getElementById(destination.substr(1))
                        .scrollIntoView({ behavior: "smooth" });
                    } else {
                      location.assign(destination);
                    }
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
            if (
              $steps["goToPartnerOverview"] != null &&
              typeof $steps["goToPartnerOverview"] === "object" &&
              typeof $steps["goToPartnerOverview"].then === "function"
            ) {
              $steps["goToPartnerOverview"] =
                await $steps["goToPartnerOverview"];
            }
          }}
          textColor={"tertiary"}
        />

        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__l4Aox
          )}
        >
          {"]"}
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text___1Z1M5
          )}
        >
          {"o21p"}
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__n7Tzw
          )}
        >
          <React.Fragment>
            {(() => {
              try {
                return $props.subdomainName;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "sub";
                }
                throw e;
              }
            })()}
          </React.Fragment>
        </div>
      </div>
      <div
        data-plasmic-name={"topnavButtonsSlot"}
        data-plasmic-override={overrides.topnavButtonsSlot}
        className={classNames(projectcss.all, sty.topnavButtonsSlot, {
          [sty.topnavButtonsSlotlayoutType_justTitle]: hasVariant(
            $state,
            "layoutType",
            "justTitle"
          ),
          [sty.topnavButtonsSlotlayoutType_titleButtons]: hasVariant(
            $state,
            "layoutType",
            "titleButtons"
          )
        })}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <React.Fragment>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__xNalS
                )}
              >
                {"["}
              </div>
              <ButtonPage
                className={classNames("__wab_instance", sty.buttonPage__ukm2Y)}
                content={"overview"}
                onClick={async () => {
                  const $steps = {};
                  $steps["goToPartnerOverview"] = true
                    ? (() => {
                        const actionArgs = { destination: `/` };
                        return (({ destination }) => {
                          if (
                            typeof destination === "string" &&
                            destination.startsWith("#")
                          ) {
                            document
                              .getElementById(destination.substr(1))
                              .scrollIntoView({ behavior: "smooth" });
                          } else {
                            location.assign(destination);
                          }
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["goToPartnerOverview"] != null &&
                    typeof $steps["goToPartnerOverview"] === "object" &&
                    typeof $steps["goToPartnerOverview"].then === "function"
                  ) {
                    $steps["goToPartnerOverview"] =
                      await $steps["goToPartnerOverview"];
                  }
                }}
                textColor={"tertiary"}
              />

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___6HzMm
                )}
              >
                {"|"}
              </div>
              <ButtonPage
                className={classNames("__wab_instance", sty.buttonPage__fBfh)}
                content={"mission"}
                onClick={async () => {
                  const $steps = {};
                  $steps["goToPartnerMission"] = true
                    ? (() => {
                        const actionArgs = { destination: `/mission` };
                        return (({ destination }) => {
                          if (
                            typeof destination === "string" &&
                            destination.startsWith("#")
                          ) {
                            document
                              .getElementById(destination.substr(1))
                              .scrollIntoView({ behavior: "smooth" });
                          } else {
                            location.assign(destination);
                          }
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["goToPartnerMission"] != null &&
                    typeof $steps["goToPartnerMission"] === "object" &&
                    typeof $steps["goToPartnerMission"].then === "function"
                  ) {
                    $steps["goToPartnerMission"] =
                      await $steps["goToPartnerMission"];
                  }
                }}
                textColor={"tertiary"}
              />

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___2Zgeq
                )}
              >
                {"|"}
              </div>
              <ButtonPage
                className={classNames("__wab_instance", sty.buttonPage__eu1Ag)}
                content={"the independent"}
                onClick={async () => {
                  const $steps = {};
                  $steps["goToPartnerOpenCall"] = true
                    ? (() => {
                        const actionArgs = { destination: `/the-independent` };
                        return (({ destination }) => {
                          if (
                            typeof destination === "string" &&
                            destination.startsWith("#")
                          ) {
                            document
                              .getElementById(destination.substr(1))
                              .scrollIntoView({ behavior: "smooth" });
                          } else {
                            location.assign(destination);
                          }
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["goToPartnerOpenCall"] != null &&
                    typeof $steps["goToPartnerOpenCall"] === "object" &&
                    typeof $steps["goToPartnerOpenCall"].then === "function"
                  ) {
                    $steps["goToPartnerOpenCall"] =
                      await $steps["goToPartnerOpenCall"];
                  }
                }}
                textColor={"tertiary"}
              />

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__rmukp
                )}
              >
                {"|"}
              </div>
              <ButtonPage
                className={classNames("__wab_instance", sty.buttonPage___1PlKc)}
                content={"early bird"}
                onClick={async () => {
                  const $steps = {};
                  $steps["goToEarlyBird"] = true
                    ? (() => {
                        const actionArgs = { destination: `/early-bird` };
                        return (({ destination }) => {
                          if (
                            typeof destination === "string" &&
                            destination.startsWith("#")
                          ) {
                            document
                              .getElementById(destination.substr(1))
                              .scrollIntoView({ behavior: "smooth" });
                          } else {
                            location.assign(destination);
                          }
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["goToEarlyBird"] != null &&
                    typeof $steps["goToEarlyBird"] === "object" &&
                    typeof $steps["goToEarlyBird"].then === "function"
                  ) {
                    $steps["goToEarlyBird"] = await $steps["goToEarlyBird"];
                  }
                }}
                textColor={"tertiary"}
              />

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__mujBp
                )}
              >
                {"|"}
              </div>
              <ButtonPage
                className={classNames("__wab_instance", sty.buttonPage__rgn6O)}
                content={"contact"}
                onClick={async () => {
                  const $steps = {};
                  $steps["goToHttpsO21PComSupport"] = true
                    ? (() => {
                        const actionArgs = {
                          destination: "https://o21p.com/support"
                        };
                        return (({ destination }) => {
                          if (
                            typeof destination === "string" &&
                            destination.startsWith("#")
                          ) {
                            document
                              .getElementById(destination.substr(1))
                              .scrollIntoView({ behavior: "smooth" });
                          } else {
                            location.assign(destination);
                          }
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["goToHttpsO21PComSupport"] != null &&
                    typeof $steps["goToHttpsO21PComSupport"] === "object" &&
                    typeof $steps["goToHttpsO21PComSupport"].then === "function"
                  ) {
                    $steps["goToHttpsO21PComSupport"] =
                      await $steps["goToHttpsO21PComSupport"];
                  }
                }}
                textColor={"tertiary"}
              />

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__f9Py
                )}
              >
                {"|"}
              </div>
              <ButtonPage
                className={classNames("__wab_instance", sty.buttonPage__oHbUq)}
                content={"join the community"}
                onClick={async () => {
                  const $steps = {};
                  $steps["goToHttpsO21PComPartnersCommunity"] = true
                    ? (() => {
                        const actionArgs = {
                          destination: "https://o21p.com/partners-community"
                        };
                        return (({ destination }) => {
                          if (
                            typeof destination === "string" &&
                            destination.startsWith("#")
                          ) {
                            document
                              .getElementById(destination.substr(1))
                              .scrollIntoView({ behavior: "smooth" });
                          } else {
                            location.assign(destination);
                          }
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["goToHttpsO21PComPartnersCommunity"] != null &&
                    typeof $steps["goToHttpsO21PComPartnersCommunity"] ===
                      "object" &&
                    typeof $steps["goToHttpsO21PComPartnersCommunity"].then ===
                      "function"
                  ) {
                    $steps["goToHttpsO21PComPartnersCommunity"] =
                      await $steps["goToHttpsO21PComPartnersCommunity"];
                  }
                }}
                textColor={"brand"}
              />

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__uqf3X
                )}
              >
                {"]"}
              </div>
            </React.Fragment>
          ),

          value: args.pageButtons
        })}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  topnav: ["topnav", "pageTitleSlot", "topnavButtonsSlot"],
  pageTitleSlot: ["pageTitleSlot"],
  topnavButtonsSlot: ["topnavButtonsSlot"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTopNav__ArgProps,
          internalVariantPropNames: PlasmicTopNav__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTopNav__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "topnav") {
    func.displayName = "PlasmicTopNav";
  } else {
    func.displayName = `PlasmicTopNav.${nodeName}`;
  }
  return func;
}

export const PlasmicTopNav = Object.assign(
  // Top-level PlasmicTopNav renders the root element
  makeNodeComponent("topnav"),
  {
    // Helper components rendering sub-elements
    pageTitleSlot: makeNodeComponent("pageTitleSlot"),
    topnavButtonsSlot: makeNodeComponent("topnavButtonsSlot"),
    // Metadata about props expected for PlasmicTopNav
    internalVariantProps: PlasmicTopNav__VariantProps,
    internalArgProps: PlasmicTopNav__ArgProps
  }
);

export default PlasmicTopNav;
/* prettier-ignore-end */
